import ConfigurationAdapter from '../../../../config/ConfigurationAdapter';
import XAPICartRepository from '../../Infrastructure/Repositories/XAPICartRepository';
import { AddToCartHandler } from './AddToCart';
import { DeleteCartHandler } from './DeleteCart';
import { GetCartHandler } from './GetCart';
import { GetTaxesHandler } from './GetTaxes';
import { RemoveFromCartHandler } from './RemoveFromCart';
import { UpdateCartHandler } from './UpdateCart';
import V4LocalStorageCartRepository from '../../Infrastructure/Repositories/V4LocalStorageCartRepository';
import StorageRepositoryFactory from '../../../Storage/Application/Factories/StorageRepositoryFactory';
function getCartRepository(context, checkoutConfig) {
  const v4Context = ConfigurationAdapter.getV4Context(context);
  const v5Context = ConfigurationAdapter.getV5Context(context);
  if (context.cartStorageConfig.implementation === 'v4-local-storage') {
    const storageRepository = StorageRepositoryFactory.resolve(context, {
      implementation: 'local-storage'
    });
    return new V4LocalStorageCartRepository(v4Context, checkoutConfig, storageRepository);
  } else {
    return new XAPICartRepository(v5Context, checkoutConfig, context.drivers.httpClient);
  }
}
export const GetCartUseCase = (context, checkoutConfig) => {
  const repository = getCartRepository(context, checkoutConfig);
  return new GetCartHandler(repository);
};
export const AddToCartUseCase = (context, checkoutConfig) => {
  const repository = getCartRepository(context, checkoutConfig);
  return new AddToCartHandler(repository);
};
export const UpdateCartUseCase = (context, checkoutConfig) => {
  const repository = getCartRepository(context, checkoutConfig);
  return new UpdateCartHandler(repository);
};
export const RemoveFromCartUseCase = (context, checkoutConfig) => {
  const repository = getCartRepository(context, checkoutConfig);
  return new RemoveFromCartHandler(repository);
};
export const DeleteCartUseCase = (context, checkoutConfig) => {
  const repository = getCartRepository(context, checkoutConfig);
  return new DeleteCartHandler(repository);
};
export const GetTaxesUseCase = (context, checkoutConfig) => {
  const repository = getCartRepository(context, checkoutConfig);
  return new GetTaxesHandler(repository);
};
